// extracted by mini-css-extract-plugin
export default {"referenceLinkRow":"ReferenceLinkRow_referenceLinkRow__jArRy","referenceLinkRemove":"ReferenceLinkRow_referenceLinkRemove__Aj0BP"};